export default "Éclairage public LED & télégestion — Collectivités | Solution Éco France";
